/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiCreateCaseRequest
 */
export interface InternalApiCreateCaseRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalApiCreateCaseRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiCreateCaseRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiCreateCaseRequest
     */
    rationaleCode: string;
}

/**
 * Check if a given object implements the InternalApiCreateCaseRequest interface.
 */
export function instanceOfInternalApiCreateCaseRequest(value: object): value is InternalApiCreateCaseRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('rationaleCode' in value) || value['rationaleCode'] === undefined) return false;
    return true;
}

export function InternalApiCreateCaseRequestFromJSON(json: any): InternalApiCreateCaseRequest {
    return InternalApiCreateCaseRequestFromJSONTyped(json, false);
}

export function InternalApiCreateCaseRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCreateCaseRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'rationaleCode': json['rationaleCode'],
    };
}

export function InternalApiCreateCaseRequestToJSON(json: any): InternalApiCreateCaseRequest {
    return InternalApiCreateCaseRequestToJSONTyped(json, false);
}

export function InternalApiCreateCaseRequestToJSONTyped(value?: InternalApiCreateCaseRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'rationaleCode': value['rationaleCode'],
    };
}

